// import React, { useState } from "react";

// const AppointmentCreate = () => {
//   const [form, setForm] = useState({ patientId: "", doctorId: "", date: "", time: "" });

//   const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     alert("Appointment booked!");
//     setForm({ patientId: "", doctorId: "", date: "", time: "" });
//   };

//   return (
//     <div className= "bg-white shadow text-center rounded w-100 mt-5 ms-3 px-3 py-2">
//       <h4>Book Appointment</h4>
//       <form onSubmit={handleSubmit} className="row g-3">
//         <div className="col-md-6"><input name="patientId" className="form-control" placeholder="Patient ID" value={form.patientId} onChange={handleChange} required /></div>
//         <div className="col-md-6"><input name="doctorId" className="form-control" placeholder="Doctor ID" value={form.doctorId} onChange={handleChange} required /></div>
//         <div className="col-md-6"><input type="date" name="date" className="form-control" value={form.date} onChange={handleChange} required /></div>
//         <div className="col-md-6"><input type="time" name="time" className="form-control" value={form.time} onChange={handleChange} required /></div>
//         <div className="col-12"><button type="submit" className="btn btn-primary border-0 rounded">Book Appointment</button></div>
//       </form>
//     </div>
//   );
// };

// export default AppointmentCreate;






import React, { useState } from "react";
import axios from "axios";
import { API_PATH } from "../Constant/constants";

const AppointmentCreate = () => {
  const [form, setForm] = useState({
    slotId: "",
    doctorId: "",
    patientFirstName: "",
    patientLastName: "",
    patientEmail: "",
    patientNumber: "",
    patientAddress: "",
    appointmentDate: "",
    reason: "",
    status: "",
    appointmentType: "",
    priority: "",
    startTime: "",
    endTime: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem("authToken");
    if (!token) {
      alert("Authorization token not found. Please log in.");
      return;
    }


    const payload = {
      id: 0,
      slotId: Number(form.slotId),
      doctorId: Number(form.doctorId),
      patientFirstName: form.patientFirstName,
      patientLastName: form.patientLastName,
      patientEmail: form.patientEmail,
      patientNumber: form.patientNumber,
      patientAddress: form.patientAddress,
      appointmentDate: form.appointmentDate,
      reason: form.reason,
      status: form.status,
      appointmentType: form.appointmentType,
      priority: form.priority,
      startTime: form.startTime,
      endTime: form.endTime,
    };

    try {
      const response = await axios.post(`${API_PATH}/appointments/book`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.status === 201 || response.status === 200) {
        alert("Patient added successfully!");
        setForm({
          slotId: "",
          doctorId: "",
          patientFirstName: "",
          patientLastName: "",
          patientEmail: "",
          patientNumber: "",
          patientAddress: "",
          appointmentDate: "",
          reason: "",
          status: "",
          appointmentType: "",
          priority: "",
          startTime: "",
          endTime: "",
        });
      } else {
        alert("Unexpected response. Please try again.");
        console.warn("Unexpected response:", response);
      }
    } catch (error) {
      if (error.response) {
        console.error("Server responded with error:", error.response);

        switch (error.response.status) {
          case 403:
            alert("Access denied (403). You might not have permission.");
            break;
          case 404:
            alert("API endpoint not found (404). Please check the API path.");
            break;
          case 500:
            alert("Internal server error (500). Please try again later.");
            break;
          default:
            alert(`Error: ${error.response.statusText}`);
            break;
        }
      } else if (error.request) {
        console.error("No response from server:", error.request);
        alert("No response from server. Please check your connection.");
      } else {
        console.error("Error setting up the request:", error.message);
        alert("Error setting up the request. Please try again.");
      }
    }
  };

  return (
    <div className=" container bg-white shadow text-center rounded w-100 mw-100 mt-5  px-3 py-2">
      <h4>Book Appointment</h4>
      <form onSubmit={handleSubmit} className="row g-3">

        <div className="col-md-6">
          <input name="slotId" type="number" className="form-control" placeholder="Slot ID" value={form.slotId} onChange={handleChange} required />
        </div>
        <div className="col-md-6">
          <input name="doctorId" type="number" className="form-control" placeholder="Doctor ID" value={form.doctorId} onChange={handleChange} required />
        </div>
        <div className="col-md-6">
          <input name="patientFirstName" className="form-control" placeholder="First Name" value={form.patientFirstName} onChange={handleChange} required />
        </div>
        <div className="col-md-6">
          <input name="patientLastName" className="form-control" placeholder="Last Name" value={form.patientLastName} onChange={handleChange} required />
        </div>
        <div className="col-md-6">
          <input name="patientEmail" type="email" className="form-control" placeholder="Email" value={form.patientEmail} onChange={handleChange} required />
        </div>
        <div className="col-md-6">
          <input name="patientNumber" className="form-control" placeholder="Phone Number" value={form.patientNumber} onChange={handleChange} required />
        </div>
        <div className="col-12">
          <input name="patientAddress" className="form-control" placeholder="Address" value={form.patientAddress} onChange={handleChange} required />
        </div>
        <div className="col-md-6">
          <input name="appointmentDate" type="date" className="form-control" value={form.appointmentDate} onChange={handleChange} required />
        </div>
        <div className="col-md-6">
          <input name="reason" className="form-control" placeholder="Reason" value={form.reason} onChange={handleChange} required />
        </div>
        <div className="col-md-4">
          <input name="status" className="form-control" placeholder="Status" value={form.status} onChange={handleChange} required />
        </div>
        <div className="col-md-4">
          <input name="appointmentType" className="form-control" placeholder="Appointment Type" value={form.appointmentType} onChange={handleChange} required />
        </div>
        <div className="col-md-4">
          <input name="priority" className="form-control" placeholder="Priority" value={form.priority} onChange={handleChange} required />
        </div>
        <div className="col-md-6">
          <input name="startTime" type="time" className="form-control" value={form.startTime} onChange={handleChange} required />
        </div>
        <div className="col-md-6">
          <input name="endTime" type="time" className="form-control" value={form.endTime} onChange={handleChange} required />
        </div>

        <div className="col-12">
          <button type="submit" className="btn btn-color border-0 rounded">Book Appointment</button>
        </div>
      </form>
    </div>
  );
};

export default AppointmentCreate;
